var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mb-3",attrs:{"no-body":""}},[_c('base-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"table-top":"","paginate":"","excel-file-name":"community-assist"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }